import React from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';
import PerishableMessage from 'pdp/components/Perishables/perishableMessage';
import PerishableCalendar from 'pdp/components/Perishables/perishableCalendar';
import { setDeliveryDate } from 'pdp/pages/ProductPage/actions';
import PropTypes from 'prop-types';
import { Perishables } from '@nmg/pdp-components';

const PerishableWrapper = (props) => {
  const {
    showPdpRedesign, expectedShipDays = 0, product, pdpLayoutTest,
  } = props;
  return showPdpRedesign
    ? (
      <Perishables
        className="product-options-perishable"
        vendorRestrictedDates={product.vendorRestrictedDates}
        expectedShipDays={isNaN(expectedShipDays) ? 7 : Number(expectedShipDays)}
        onDeliveryDateChange={props.setDeliveryDate}
      />
    )
    : (
      <>
        <PerishableMessage perishable={product.perishable} pdpLayoutTest={pdpLayoutTest} />
        <PerishableCalendar
          productId={product.id}
          expectedShipDays={expectedShipDays || null}
        />
      </>
    );
};

const mapStateToProps = (state) => {
  return {
    showPdpRedesign: get(state, 'abTestsOpt.nmpd0004.variation', 'a') === 'b',
    pdpLayoutTest: get(state, 'abTestsOpt.pdplayout.variation', 'pdp_layout_off'),
  };
};

const mapDispatchToProps = (dispatch, { product: { id: productId } }) => ({
  setDeliveryDate: (...args) => dispatch(setDeliveryDate(productId, ...args)),
});

PerishableWrapper.propTypes = {
  product: PropTypes.object,
  expectedShipDays: PropTypes.string,
};

PerishableWrapper.defaultProps = {
  product: {},
  expectedShipDays: '0',
};

export default connect(mapStateToProps, mapDispatchToProps)(PerishableWrapper);
